import AccountsPayableTable from './AccountsPayableTable';
export default AccountsPayableTable;
